import { Button, Modal } from 'antd';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import HeadUpIcon from '../../assets/HeadUpIcon.svg';
import congratulaionIcon from '../../assets/Congratulations.svg';
import OhNoIcon from '../../assets/OhNoIcon.svg';
import { useSendTaskMutation } from '../../api/tenders';
import '../../components/Modals/Modals.scss';
import { tenderDataProps } from '../../pages/TenderViewPage/types';
import { Loader } from '../Loader/Loader';
import moment from 'moment';

interface HeadsUpI {
    openModal: boolean;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
    data: tenderDataProps;
    setTrigger: Dispatch<SetStateAction<boolean>>;
    /** When set, closing the flow (Got it) does not call send task — runs after the user acknowledges. */
    onAcknowledge?: () => void;
}

export const CompletionResultModal: FC<HeadsUpI> = ({ openModal, setOpenModal, data, setTrigger, onAcknowledge }) => {
    const [sendTask, { isLoading: isLoadingSendTask, isSuccess: isSuccessSent }] = useSendTaskMutation();
    const [step, setStep] = useState(1);

    useEffect(() => {
        if (openModal) setStep(1);
    }, [openModal]);

    const deadline = moment(data.tasks_deadline_at);
    const today = moment();
    const isWithinDeadline = today.isSameOrBefore(deadline, 'day');

    const isTwoModals =
        data?.phase_tasks?.[0]?.action === 'define_phase_questionnaire' ||
        (data.phase === 'evaluate_4' && data?.is_show_multi_award);

    const sendTaskFunc = async () => {
        let formData = {
            id: data?.id
        };
        try {
            await sendTask(formData).unwrap();
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    const handleComplete = () => {
        if (onAcknowledge) {
            setOpenModal(false);
            onAcknowledge();
            return;
        }
        if (isLoadingSendTask) return;
        sendTaskFunc();
    };

    useEffect(() => {
        if (isSuccessSent) {
            setOpenModal(false);
        }
    }, [isSuccessSent]);

    return (
        <Modal
            className="confirmModal"
            centered
            open={openModal}
            closeIcon={<div style={{ display: 'none', cursor: 'context-menu' }}></div>}
            width={600}
            footer={<></>}
        >
            {isTwoModals ? (
                <>
                    {isWithinDeadline ? (
                        <div className="modal">
                            {step === 1 && (
                                <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                                    <div className="main__title" style={{ margin: '0 0 6px 0', textAlign: 'start' }}>
                                        <div>
                                            <img src={congratulaionIcon} className="main__icon" />
                                            <div className="main__title-no-head">Congratulations</div>
                                        </div>
                                        Great job completing your task on time! You've earned{' '}
                                        {Math.abs(today.diff(deadline, 'days'))} extra days for your next task.
                                        <br />
                                        <br />
                                        Keep up the fantastic work!
                                    </div>
                                </div>
                            )}
                            {step === 2 && (
                                <>
                                    {data?.phase === 'define' && (
                                        <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                                            <div
                                                className="main__title"
                                                style={{ margin: '0 0 6px 0', textAlign: 'center' }}
                                            >
                                                <div>
                                                    <img src={HeadUpIcon} className="main__icon" />
                                                    <div className="main__title-no-head">
                                                        Heads Up! We’ll Be in Touch Soon!
                                                    </div>
                                                </div>
                                                A member of our team will be in touch to confirm your site visit.
                                                <br />
                                                <br />
                                                Watch out for a message from us soon!
                                            </div>
                                        </div>
                                    )}
                                    {data.phase === 'evaluate_4' && data?.is_show_multi_award && (
                                        <div className="modal">
                                            <div className="modal__header meeting" style={{ height: '88px' }}>
                                                <div className="modal__title name-title">
                                                    Managing Supplier Transitions
                                                </div>
                                            </div>

                                            <div
                                                className="modal__main main"
                                                style={{ padding: '24px 56px 43px 56px' }}
                                            >
                                                <div className="main__title" style={{ margin: '0 0 6px 0' }}>
                                                    Unsuccessful suppliers will only be notified once the agreement with
                                                    your appointed supplier has been finalised.
                                                    <br />
                                                    <br />
                                                    However, if your appointed supplier is different from your incumbent
                                                    supplier, we recommend scheduling a meeting with your incumbent
                                                    supplier as a courtesy. This provides an opportunity for them to
                                                    assist in ensuring a smooth transition before formal notifications
                                                    are sent.
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            <div className="multipleModals">
                                <div className="multipleModals__steps">
                                    <div className={`multipleModals__step`}></div>
                                    <div className={`multipleModals__step ${step === 1 ? 'inactive' : ''}`}></div>
                                </div>
                                {step === 1 && (
                                    <Button
                                        className={`tasks__next-btn`}
                                        style={{ width: '120px' }}
                                        type="primary"
                                        onClick={() => {
                                            setStep(2);
                                        }}
                                    >
                                        Next
                                    </Button>
                                )}
                                {step === 2 && (
                                    <div style={{ display: 'flex' }}>
                                        <Button
                                            className={`tasks__next-btn`}
                                            style={{ width: '120px', margin: '0 20px 0 0' }}
                                            onClick={() => {
                                                setStep(1);
                                            }}
                                        >
                                            Previous
                                        </Button>
                                        <Button
                                            className={`tasks__next-btn`}
                                            style={{ width: '120px' }}
                                            type="primary"
                                            onClick={handleComplete}
                                        >
                                            {isLoadingSendTask && !onAcknowledge ? <Loader /> : 'Got it'}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="modal">
                            {step === 1 && (
                                <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                                    <div className="main__title" style={{ margin: '0 0 6px 0', textAlign: 'start' }}>
                                        <div>
                                            <img src={OhNoIcon} className="main__icon" />
                                            <div className="main__title-no-head">Oh, no</div>
                                        </div>
                                        Your supplier appointment has been moved out due to the delay. But don’t be
                                        discouraged - you can still catch up by completing your upcoming tasks earlier.
                                        <br />
                                        <br />
                                        You’ve got this! 💪
                                    </div>
                                </div>
                            )}
                            {step === 2 && (
                                <>
                                    {data?.phase === 'define' && (
                                        <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                                            <div
                                                className="main__title"
                                                style={{ margin: '0 0 6px 0', textAlign: 'center' }}
                                            >
                                                <div>
                                                    <img src={HeadUpIcon} className="main__icon" />
                                                    <div className="main__title-no-head">
                                                        Heads Up! We’ll Be in Touch Soon!
                                                    </div>
                                                </div>
                                                A member of our team will be in touch to confirm your site visit.
                                                <br />
                                                <br />
                                                Watch out for a message from us soon!
                                            </div>
                                        </div>
                                    )}
                                    {data.phase === 'evaluate_4' && data?.is_show_multi_award && (
                                        <div className="modal">
                                            <div className="modal__header meeting" style={{ height: '88px' }}>
                                                <div className="modal__title name-title">
                                                    Managing Supplier Transitions
                                                </div>
                                            </div>

                                            <div
                                                className="modal__main main"
                                                style={{ padding: '24px 56px 43px 56px' }}
                                            >
                                                <div className="main__title" style={{ margin: '0 0 6px 0' }}>
                                                    Unsuccessful suppliers will only be notified once the agreement with
                                                    your appointed supplier has been finalised.
                                                    <br />
                                                    <br />
                                                    However, if your appointed supplier is different from your incumbent
                                                    supplier, we recommend scheduling a meeting with your incumbent
                                                    supplier as a courtesy. This provides an opportunity for them to
                                                    assist in ensuring a smooth transition before formal notifications
                                                    are sent.
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            <div className="multipleModals">
                                <div className="multipleModals__steps">
                                    <div className={`multipleModals__step`}></div>
                                    <div className={`multipleModals__step ${step === 1 ? 'inactive' : ''}`}></div>
                                </div>
                                {step === 1 && (
                                    <Button
                                        className={`tasks__next-btn`}
                                        style={{ width: '120px' }}
                                        type="primary"
                                        onClick={() => {
                                            setStep(2);
                                        }}
                                    >
                                        Next
                                    </Button>
                                )}
                                {step === 2 && (
                                    <div style={{ display: 'flex' }}>
                                        <Button
                                            className={`tasks__next-btn`}
                                            style={{ width: '120px', margin: '0 20px 0 0' }}
                                            onClick={() => {
                                                setStep(1);
                                            }}
                                        >
                                            Previous
                                        </Button>
                                        <Button
                                            className={`tasks__next-btn`}
                                            style={{ width: '120px' }}
                                            type="primary"
                                            onClick={handleComplete}
                                        >
                                            {isLoadingSendTask && !onAcknowledge ? <Loader /> : 'Got it'}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </>
            ) : (
                ''
            )}
            {!isTwoModals ? (
                isWithinDeadline ? (
                    <>
                        <div className="modal">
                            <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                                <div className="main__title" style={{ margin: '0 0 6px 0', textAlign: 'start' }}>
                                    <div>
                                        <img src={congratulaionIcon} className="main__icon" />
                                        <div className="main__title-no-head">Congratulations</div>
                                    </div>
                                    Great job completing your task on time! You've earned{' '}
                                    {Math.abs(today.diff(deadline, 'days'))} extra days for your next task.
                                    <br />
                                    <br />
                                    Keep up the fantastic work!
                                </div>
                            </div>
                            <Button
                                className={`tasks__next-btn`}
                                style={{ width: '487px', margin: '0 57px' }}
                                type="primary"
                                onClick={handleComplete}
                            >
                                {isLoadingSendTask && !onAcknowledge ? <Loader /> : 'Got it'}
                            </Button>
                        </div>
                    </>
                ) : (
                    <div className="modal">
                        <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                            <div className="main__title" style={{ margin: '0 0 6px 0', textAlign: 'start' }}>
                                <div>
                                    <img src={OhNoIcon} className="main__icon" />
                                    <div className="main__title-no-head">Oh, no</div>
                                </div>
                                Your supplier appointment has been moved out due to the delay. But don’t be discouraged
                                - you can still catch up by completing your upcoming tasks earlier.
                                <br />
                                <br />
                                You’ve got this! 💪
                            </div>
                        </div>
                        <Button
                            className={`tasks__next-btn`}
                            style={{ width: '487px', margin: '0 57px' }}
                            type="primary"
                            onClick={handleComplete}
                        >
                            {isLoadingSendTask && !onAcknowledge ? <Loader /> : 'Got it'}
                        </Button>
                    </div>
                )
            ) : (
                ''
            )}
        </Modal>
    );
};
